import { css, SerializedStyles } from '@emotion/react';
import { mediaQueries, weights } from '@upsun/react-component-library/src/styles/css-utils';
import React, { ReactNode } from 'react';

type BoldCellProps = {
  comingSoon?: boolean,
  children: ReactNode,
  css?: SerializedStyles
};

const BoldCell:React.FC<BoldCellProps> = ({ comingSoon, children, ...props }) => {
  const containerStyles = css`
    font-weight: ${weights.bold};

    ${mediaQueries.md} {
      width: 50%;
    }
  `;

  return (
    <td css={containerStyles} {...props}>{children}</td>
  );
};

export default BoldCell;